import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0494495f")
const _hoisted_1 = {
  key: 0,
  class: "menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Image select", -1)
const _hoisted_3 = {
  key: 1,
  class: "inputs"
}
const _hoisted_4 = {
  key: 2,
  class: "functions"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_FileUploader = _resolveComponent("FileUploader")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
    class: _normalizeClass({
    imageSelector:true,
    previewing:_ctx.imagePreview
  })
  }, [
    (!_ctx.imagePreview && !_ctx.uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_IconButton, {
            icon: "cross",
            type: "svg",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.imagePreview && !_ctx.uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass({inactive:_ctx.mode=='text'})
          }, [
            _createVNode(_component_FileUploader, {
              white: true,
              noDisplay: true,
              acceptedTypes: "image/*",
              onPreview: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploaderPreview('upload',$event))),
              onUploading: _cache[2] || (_cache[2] = ($event: any) => (_ctx.status=-1)),
              onUploaded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploaded($event))),
              onError: _cache[4] || (_cache[4] = ($event: any) => (_ctx.status=2)),
              ref: "fileUploader"
            }, null, 512)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass({url:true, inactive:_ctx.mode=='upload'})
          }, [
            _createVNode(_component_TextInput, {
              label: "Alternatively,",
              placeholder: "Image url",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.uploaderPreview('text',$event)))
            })
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.imagePreview && !_ctx.uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_IconButton, {
            white: true,
            text: "back",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploaderClear()))
          }),
          _createVNode(_component_IconButton, {
            ":autoplay": true,
            loop: _ctx.status == -1,
            icon: _ctx.status == -1?'loader_spinner':_ctx.status == 1?'tick':_ctx.status == 2?'cross':'',
            success: _ctx.status == 1,
            fail: _ctx.status == 2,
            text: "Submit",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.upload()))
          }, null, 8, ["loop", "icon", "success", "fail"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}